
export default function MembersCTA() {
  return (
    <section 
      className="py-20 bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(59, 130, 246, 0.9), rgba(37, 99, 235, 0.9)), url('https://public.readdy.ai/ai/img_res/eb3a20eb27a95273e4a6f7e3af7e0b0b.jpg')`
      }}
    >
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center text-white">
          <h2 className="text-4xl font-bold mb-6">
            Join Our Partner Network
          </h2>
          <p className="text-xl mb-10 leading-relaxed">
            Connect with industry leaders, access exclusive opportunities, and accelerate your business growth through strategic partnerships.
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            <div className="text-center">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-handshake-line text-2xl w-8 h-8 flex items-center justify-center"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">Strategic Partnerships</h3>
              <p className="text-white/90">Build meaningful business relationships</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-global-line text-2xl w-8 h-8 flex items-center justify-center"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">Global Reach</h3>
              <p className="text-white/90">Expand into new markets worldwide</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-rocket-line text-2xl w-8 h-8 flex items-center justify-center"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">Accelerated Growth</h3>
              <p className="text-white/90">Scale your business faster together</p>
            </div>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="bg-white text-blue-600 hover:bg-gray-100 px-8 py-4 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
              Become a Partner
            </button>
            <button className="border-2 border-white text-white hover:bg-white hover:text-blue-600 px-8 py-4 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
              Contact Us
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
